import Filter from 'components/framework/filters/Filter';
import { type User, type WorkflowStatus } from '../models';
import { type ReferenceInterface } from '../models/generated/types';
import type ApplicationModel from '../ApplicationModel';

export default class SearchFilter extends Filter {
  string: string;

  constructor() {
    super();
    this.string = '';
  }

  getValue() {
    return this.string;
  }

  toBookmarkConfiguration() {
    return [this.string];
  }

  set(string: string) {
    this.string = string.toLowerCase();
  }

  setItems(items: string[]) {
    this.set(items[0] || '');
  }

  clearItems() {
    this.string = '';
  }

  get shouldFilter() {
    return this.string.length !== 0;
  }

  matches(
    record: ApplicationModel & { name: string } & ReferenceInterface & {
        workflowStatus?: WorkflowStatus;
        teamWorkflowStatus?: WorkflowStatus;
        assignedToUser?: User;
        tags?: { name: string }[];
        ideaCategories?: { name: string }[];
      }
  ) {
    if (!this.shouldFilter) return true;

    return (
      this.matchesText(record.name) ||
      this.matchesText(record.referenceNum || '') ||
      this.matchesText(record.workflowStatus?.name) ||
      this.matchesText(record.teamWorkflowStatus?.name) ||
      this.matchesText(record.assignedToUser?.name) ||
      (record.modelConstructor.hasField('tags') &&
        record.tags &&
        record.tags.some(tag => this.matchesText(tag.name))) ||
      (record.modelConstructor.hasField('ideaCategories') &&
        record.ideaCategories?.some(c => this.matchesText(c.name))) ||
      false
    );
  }

  matchesText(string?: string) {
    if (!string) return false;

    return string.toLowerCase().includes(this.string);
  }
}
